import Text from 'common/ui/Text';
import { Colors } from 'styles';

type RightDrawerEmptyPreviewStateProps = {
  children: React.ReactNode;
  marginTop?: number;
};

export const RightDrawerEmptyPreviewState = ({
  children,
  marginTop = 24,
}: RightDrawerEmptyPreviewStateProps): React.ReactElement => {
  return (
    <Text
      variant="body2"
      color={Colors.gray8}
      css={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginTop,
      }}
    >
      {children}
    </Text>
  );
};
